<template>
  <v-app>
    <!-- Navigation Drawer -->
    <v-navigation-drawer app temporary overflow :dark="info.theme_menu_variant == 'dark'" v-model="drawer" class="menuBackground">
      <v-card-text class="text-center menuBackground">
        <img :src="info.app_logo"/>
      </v-card-text>
      <v-card-text v-if="user" class="text-center white--text">
        Olá {{ user.name.split(' ')[0] }}
      </v-card-text>
      <v-list dense nav>
        <v-list-item v-if="cartCount" :to="{name: 'cart'}">
          <v-list-item-icon>
            <v-icon>mdi-cart</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Carrinho</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <template v-if="isAuthenticated">
          <v-list-item color="accent" v-for="(item, i) in allMenus" :key="i" :to="item.link">
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <template v-else>
          <v-list-item :to="{ name: 'auth.login' }">
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Login</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
    <!-- App Bar -->
    <v-app-bar app fixed color="menuBackground">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" class="hidden-sm-and-up menuColor--text"/>
      <v-toolbar-title>
        <router-link flat :to="{ name: 'ambienteAluno.dashboard' }">
          <v-img :src="info.app_logo2" contain max-height="50"/>
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-xs-only">
        <v-btn v-if="cartCount" text :to="{name: 'cart'}" color="menuColor">
          <v-badge left color="menuColor">
            <template v-slot:badge>
              <span>{{ cartCount }}</span>
            </template>
            <v-icon left>mdi-cart</v-icon>
          </v-badge>
          Carrinho
        </v-btn>
        <template v-if="isAuthenticated">
          <v-btn text v-for="(item, i) in menu.menu" :key="i" :to="item.link" color="menuColor">
            <v-icon left>{{item.icon}}</v-icon>
            {{item.title}}
          </v-btn>
          <v-menu left bottom v-if="user">
            <template v-slot:activator="{ on, attrs }">
              <template v-if="user.name.split(' ').length">
                <v-btn text v-bind="attrs" v-on="on" color="menuColor">
                  <v-icon left>mdi-account</v-icon> Olá {{ user.name.split(' ')[0] }}
                </v-btn>
              </template>
              <template v-else>
                <v-btn icon v-bind="attrs" v-on="on" color="menuColor">
                  <v-icon>mdi-account</v-icon>
                </v-btn>
              </template>
            </template>
            <v-list>
              <v-list-item v-for="(item, i) in menu.menuProfile" :key="i" router :to="item.link">
                <v-list-item-title>{{item.title}}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-else>
          <v-btn text :to="{ name: 'auth.login' }">
            <v-icon left>mdi-account</v-icon>
            Login
          </v-btn>
        </template>
      </v-toolbar-items>
    </v-app-bar>
    <!-- Main -->
    <v-main>
      <v-container :fluid="this.$route.name === 'salaDeAula' || this.$route.name === 'salaDeAula.aula'">
        <slot transition="slide-y-transition"></slot>
      </v-container>
    </v-main>
    <!-- Footer -->
    <v-footer app dark fixed color="backgroundVariant">
      <v-card-text class="text-center">
        &copy; {{ year }} NovaTechbr. Feito com <v-icon class="red--text text--darken-2" title="Amor">mdi-heart</v-icon> em GYN.
      </v-card-text>
    </v-footer>
  </v-app>
</template>

<script>
import Menu from '@/components/Utils/Menu'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      drawer: null,
      menu: Menu
    }
  },
  mounted () {
    this.$vuetify.theme.dark = this.info.theme_app_variant === 'dark'
  },
  computed: {
    ...mapGetters({
      user: 'App/user',
      isAuthenticated: 'App/isAuthenticated',
      cartCount: 'Cart/getCartCount',
      info: ['App/info']
    }),
    allMenus () {
      return this.menu.menu.concat(this.menu.menuProfile)
    },
    year () {
      return new Date().toLocaleString(window.navigator.language, {
        year: 'numeric'
      })
    }
  }
}
</script>
